import * as Types from 'src/actions/sector-of-interest/index/Types';
import {
  IndexSectorsOfInterestAction,
} from 'src/actions/sector-of-interest/index/IndexSectorsOfInterest.actions';
import SectorOfInterest from 'src/entities/SectorOfInterest';

export interface IndexSectorOfInterestState {
  sectorsOfInterest: SectorOfInterest[];
  loading: boolean;
  error: boolean;
}

const initialState: IndexSectorOfInterestState = {
  sectorsOfInterest: [],
  loading: false,
  error: false,
};

export function IndexSectorOfInterestReducer(state: IndexSectorOfInterestState = initialState,
                                             action: IndexSectorsOfInterestAction): IndexSectorOfInterestState {
  switch (action.type) {
    case Types.INDEX_SECTORS_OF_INTEREST_ATTEMPT:
      return { ...state, loading: true, error: false };
    case Types.INDEX_SECTORS_OF_INTEREST_SUCCESS:
      return { ...state, sectorsOfInterest: action.payload, loading: false, error: false };
    case Types.INDEX_SECTORS_OF_INTEREST_FAILURE:
      return { ...state, loading: false, error: true, sectorsOfInterest: [] };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sector-of-interest/IndexSectorsOfInterestReducer.tsx